import { render, staticRenderFns } from "./slope-info.vue?vue&type=template&id=fb2c1d0c&scoped=true"
import script from "./slope-info.vue?vue&type=script&lang=js"
export * from "./slope-info.vue?vue&type=script&lang=js"
import style0 from "./slope-info.vue?vue&type=style&index=0&id=fb2c1d0c&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2c1d0c",
  null
  
)

export default component.exports